export default {
    vehicleTypes: [],
    vendorCategories: [],
    vendorClassification: [],
    data: [],
    total: {
        totalItems: 5,
        totalPages: 5,
    },

    simpleDetail: {},

};
